/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Statusgroup1Inputs */

const en__field_statusgroup1 = /** @type {(inputs: _Field_Statusgroup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`status group`)
};

const de__field_statusgroup1 = /** @type {(inputs: _Field_Statusgroup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Gruppe`)
};

/**
* | output |
* | --- |
* | "status group" |
*
* @param {_Field_Statusgroup1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_statusgroup1 = /** @type {((inputs?: _Field_Statusgroup1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Statusgroup1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_statusgroup1(inputs)
	return de__field_statusgroup1(inputs)
});
export { _field_statusgroup1 as "_field_statusGroup" }